import React, { FC } from "react";
import {
  Box,
  Drawer,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  IconButton,
  Container,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { sortDirectionVal } from "common/constants/products";
import { H4 } from "components/Typography";
import BuildFilterCard from "./BuildFilterCard";

interface Props {
  open: boolean;
  sortDirection: string;
  onClose: () => void;
  onChangeSortPrice: (field: string, direction: "asc" | "desc") => void;
  onCategoryChange: (category: any) => void;
  onChangePriceRange: (range: any) => void;
  onHandleClearKeyword: () => void;
}

export const BuildsFilterDrawer: FC<Props> = ({
  open,
  sortDirection,
  onClose,
  onChangeSortPrice,
  onCategoryChange,
  onChangePriceRange,
  onHandleClearKeyword,
}) => {
  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          width: 350, 
          maxWidth: "100vw", 
          overflowY: "auto",
          overflowX: "hidden", 
          padding: "5px",
          boxSizing: "border-box", 
          "&::-webkit-scrollbar": { width: "3px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0,0,0,0.3)",
            borderRadius: "4px",
          },
        },
      }}
    >
      <Container
        sx={{
          maxWidth: "100%", 
          overflowX: "hidden",
        }}
      >
        <IconButton
          sx={{ position: "absolute", top: 10, right: 10 }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{ mt: "2rem" }}>
          <H4 mb={"1rem"}>Filters</H4>

          <FormControl sx={{ width: "100%" }}>
            <InputLabel id="sort-direction">Sort By Price</InputLabel>
            <Select
              sx={{ height: "45px", textAlign: "left" }}
              labelId="sort-direction"
              value={sortDirection}
              onChange={(e) =>
                onChangeSortPrice(
                  "amount",
                  e.target.value === "Highest to Lowest" ? "desc" : "asc"
                )
              }
              input={
                <OutlinedInput label="sort-direction" sx={{ height: 40 }} />
              }
            >
              {sortDirectionVal.map((sortDir, index) => (
                <MenuItem key={index} value={sortDir}>
                  {sortDir}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <BuildFilterCard
          onchange={onCategoryChange}
          onChangePriceRange={onChangePriceRange}
          onHandleClearKeyword={onHandleClearKeyword}
        />
      </Container>
    </Drawer>
  );
};
